import { Filter, Filters } from '@cimplico/components';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useEntities } from '../../../../queries/use-entities';
import { useGroups } from '../../../../queries/use-groups';

type UserOverviewInsightsFilterProps = {
    onFilterChange: (filter: string) => void;
};

function UserOverviewInsightsFilter({ onFilterChange }: UserOverviewInsightsFilterProps): JSX.Element {
    const { id } = useParams();
    const groupsQuery = useGroups({ page: 1, search: '', sort: '', filter: '' });
    const entitiesQuery = useEntities({ page: 1, search: '', sort: '', filter: '' });

    const filterOptions: Filters = useMemo(
        () => [
            {
                id: 'group',
                isMulti: true,
                options: (groupsQuery.data?.groups ?? []).map((group) => ({
                    active: false,
                    label: group.name,
                    value: group.id,
                })),
                title: 'Group',
                type: 'select',
            },
            {
                id: 'entity',
                isMulti: true,
                options: (entitiesQuery.data?.entities ?? []).map((entity) => ({
                    active: false,
                    label: entity.name,
                    value: entity.id,
                })),
                title: 'Entity',
                type: 'select',
            },
            { type: 'date', title: 'Period', option: {}, id: 'period' },
        ],
        [groupsQuery.data?.groups, entitiesQuery.data?.entities]
    );

    function handleFilterChange(queryString: string): void {
        onFilterChange(`user=${id}&${queryString}`);
    }

    return <Filter onChange={({ queryString }): void => handleFilterChange(queryString)} filters={filterOptions} enableV2Query />;
}

export default UserOverviewInsightsFilter;
